import { createStore } from '@stencil/store';
// Exterior: Front, Driver, Passenger, Windows/Lights
// - Front: Hood, Grille, Front Bumper, Molding/Trim
// - Driver: Front Fender, Front Door, Rear Door, Rear Panel, Rocker Panel, Tires & RIims, Molding/Trim, Brakes
// - Rear: Roof, Liftgate, Bumper, Molding/Trim
// - Windows/Lights: Headlights, Windshield, Mirror, Side Windows, Rear Windows, Taillights

const initialState = {
  questions: [],
  questionsHood: [],
  questionsGrille: [],
  questionsFrontBumper: [],
  questionsFrontMoldingTrim: [],
  questionsDriverFrontFender: [],
  questionsDriverFrontDoor: [],
  questionsDriverRearDoor: [],
  questionsDriverRearPanel: [],
  questionsDriverRockerPanel: [],
  questionsDriverMoldingTrim: [],
  questionsPassengerFrontFender: [],
  questionsPassengerFrontDoor: [],
  questionsPassengerRearDoor: [],
  questionsPassengerRearPanel: [],
  questionsPassengerRockerPanel: [],
  questionsPassengerMoldingTrim: [],
  questionsTiresRims: [],
  questionsBrakes: [],
  questionsRoof: [],
  questionsTrunk: [],
  questionsRearBumper: [],
  questionsRearMoldingTrim: [],
  questionsHeadlights: [],
  questionsWindshield: [],
  questionsMirrors: [],
  questionsSideWindows: [],
  questionsRearWindow: [],
  questionsTaillights: [],
  conditionPageFrontBadge: 0,
  conditionPageDriverBadge: 0,
  conditionPagePassengerBadge: 0,
  conditionPageRearBadge: 0,
  conditionPageWindowsLightsBadge: 0,
};

const { on, onChange, state, reset } = createStore(initialState);

export { on, onChange, state, reset };
export default state;
